import React, { useEffect, useState } from 'react';

import { MaterialSearchDropdownMulti } from '~/src/dash/components/material-search-dropdown-multi';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import { getDeviceEnvironmentAsItems } from '~/src/dash/utils/device-environments';

interface IProps {
  name: string;
  onChange: (deviceIDs: string) => void;
  publisherID: string;
  deviceIDs: string;
  // default false
  disabled?: boolean;
  // default true
  enableMultiSelect?: boolean;
}

export const DeviceTargetingMultiSelect = function ({
  onChange,
  disabled = false,
  deviceIDs = '',
  publisherID,
  enableMultiSelect = true,
}: IProps) {
  const [deviceMenuList, setDeviceMenuList] = useState<IMenuList>({});

  function handleMenuSelectionDone(menuList: IMenuList) {
    const deviceIDs = Object.values(menuList)
      .filter((src: IListItem) => {
        return src.selected;
      })
      .map((src: IListItem) => src.ID);
    if (deviceIDs.length === Object.values(menuList).length) {
      // if all are selected, use 0 which represents all
      onChange('0');
      return;
    }
    onChange(deviceIDs.join(','));
  }

  useEffect(() => {
    setDeviceMenuList(getDeviceEnvironmentAsItems(deviceIDs));
  }, [publisherID]);

  return (
    <MaterialSearchDropdownMulti
      getValueFromSearchElement={(src: IListItem) => src.title}
      selectAll={enableMultiSelect}
      menuTitle='Devices'
      list={deviceMenuList}
      disabled={disabled}
      onChange={setDeviceMenuList}
      handleMenuAcceptClick={handleMenuSelectionDone}
      isNoneSelectedAllSelected={false}
      helperText='Choose which devices to target.'
      enableMultiSelect={enableMultiSelect}
      width='400'
    />
  );
};
